import { Alert, Button, TextField } from "@mui/material";
import { CardCvcElement, CardElement, CardExpiryElement, CardNumberElement, Elements, ElementsConsumer, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { Backend } from "../../services/Backend";

const stripePromise = loadStripe('pk_test_51OJIb3GmUxtE5zwryxhgATv4mrH7w0B3MqTyySZxdnoXCeRwjJIPcHHMJbGjROae2xhEnakS2Rg8hcZuVAPQ4nrx00OepCml8z');

const options = {
    mode: 'payment',
    amount: 1099,
    currency: 'usd',
};

export default function PaymentSettingPage() {
    const [cardToken, setCardToken] = useState(null);
    const [openCardForm, setOpenCardForm] = useState(false);

    const toggleCardForm = () => setOpenCardForm(!openCardForm);
    useEffect(() => {
        Backend.get("user/me/payment")
            .then(res => setCardToken(res.source));
    }, []);

    return <div>
        <p className="text-2xl">Payment</p>
        { !cardToken ? <p className="italic text-gray-600 my-2">You don't have a payment method added</p> 
            : <p className="my-2 font-bold">Payment verified</p>}
        
        { !openCardForm ? <Button variant="contained" onClick={toggleCardForm}>Add payment</Button> : <Button variant="outlined"onClick={toggleCardForm} >Close</Button> }

        {openCardForm ? <div className="w-[50%]">
            <Elements stripe={stripePromise}  options={options}>
                <CardForm />
            </Elements>
        </div>
        : ""}
    </div>
}

function CardForm() {
    const [error, setError] = useState("");
    const stripe = useStripe();
    const elements = useElements();
    
    const handleSubmit = (e) => {
        e.preventDefault();
        const card = elements.getElement("cardNumber");
        
        stripe.createToken(card)
            .then(res => {
                if(res.error) {
                    setError(res.error.message);
                    return;
                }

                const token = res.token.id;
                Backend.put("user/me/payment", token)
                    .then(res => console.log(res));
            });
    }

    return <div>
        <form onSubmit={handleSubmit}>
            {error !== "" ? <Alert severity="error" className="mt-4">{error}</Alert> : ""}
            <form className="flex flex-wrap gap-3 w-full my-3">
                <label class="relative w-full flex flex-col">
                    <span class="font-bold mb-1">Card number:</span>
                    <div className="rounded-md peer pl-12 pr-2 py-2 pt-3 border-2 border-gray-200 placeholder-gray-300">
                        <CardNumberElement options={ { style: { base: { fontSize: "16px"} } } } />
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" class="absolute bottom-0 left-0 -mb-0.5 transform translate-x-1/2 -translate-y-1/2 text-black peer-placeholder-shown:text-gray-300 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                    </svg>
                </label>

                <div className="flex items-center justify-between w-full">
                    <label class="relative flex flex-col w-[47%]">
                        <span class="font-bold mb-1">Expire date</span>
                        <div className="rounded-md peer pl-12 pr-2 py-2 pt-3 border-2 border-gray-200 placeholder-gray-300">
                        <CardExpiryElement options={ { style: { base: { fontSize: "16px"} } } } />
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="absolute bottom-0 left-0 -mb-0.5 transform translate-x-1/2 -translate-y-1/2 text-black peer-placeholder-shown:text-gray-300 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                    </label>

                    <label class="relative flex flex-col w-[47%]">
                        <span class="font-bold flex items-center gap-3 mb-1">
                        CVC/CVV
                        </span>
                        <div className="rounded-md peer pl-12 pr-2 py-2 pt-3 border-2 border-gray-200 placeholder-gray-300 ">
                            <CardCvcElement options={ { style: { base: { fontSize: "16px"} } } } />
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="absolute bottom-0 left-0 -mb-0.5 transform translate-x-1/2 -translate-y-1/2 text-black peer-placeholder-shown:text-gray-300 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                    </label>
                </div>

            </form>
           
            <Button variant="contained" color="success" type="submit">Save</Button>
        </form>
    </div>
}